/**
 * TROVLY Theme — Global Behavior
 *
 * Responsibilities:
 *  • Cart icon click → open drawer
 *  • AJAX add-to-cart for quick-buy forms (non-product-page)
 *  • Scroll reveal
 *  • Cart count badge helper
 *
 * NOTE: openCartDrawer / closeCartDrawer / fetchCart / renderItems are
 * defined in snippets/cart-drawer.liquid and set on window.*
 * Do NOT redeclare them here — function declarations hoist and override
 * the snippet's window assignments.
 */

document.addEventListener('DOMContentLoaded', function() {

  /* ── Cart icon → open drawer ── */
  var cartBtn = document.getElementById('CartIconBtn');
  if (cartBtn) {
    cartBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
    });
  }

  /* ── Product page quantity stepper ── */
  var qtyDec = document.querySelector('[data-qty-dec]');
  var qtyInc = document.querySelector('[data-qty-inc]');
  var qtyInp = document.querySelector('.pdp-qty-input');
  if (qtyDec && qtyInc && qtyInp) {
    qtyDec.addEventListener('click', function() {
      var v = Math.max(1, (parseInt(qtyInp.value, 10) || 1) - 1);
      qtyInp.value = v;
    });
    qtyInc.addEventListener('click', function() {
      var v = (parseInt(qtyInp.value, 10) || 1) + 1;
      qtyInp.value = v;
    });
  }

  /* ── PDP grouped variant picker (multi-option products) ──
   * Two or more rows of chips (e.g. Model + Pack Size). Each click updates
   * that row's active chip, then we look up the matching variant by combining
   * all currently selected option values. */
  var groupedWrap = document.querySelector('[data-pdp-grouped]');
  var variantMapEl = document.getElementById('pdp-variant-map');
  if (groupedWrap && variantMapEl) {
    var variantMap = [];
    try { variantMap = JSON.parse(variantMapEl.textContent); } catch (e) { variantMap = []; }

    function currentSelection() {
      var sel = [];
      groupedWrap.querySelectorAll('.pdp-vgroup').forEach(function(grp) {
        var dropdown = grp.querySelector('[data-pdp-group-select]');
        if (dropdown) {
          sel.push(dropdown.value);
        } else {
          var active = grp.querySelector('.pdp-vchip--active');
          sel.push(active ? active.getAttribute('data-value') : '');
        }
      });
      return sel;
    }

    function findVariant(sel) {
      var key = sel.join('|||');
      for (var i = 0; i < variantMap.length; i++) {
        if (variantMap[i].key === key) return variantMap[i];
      }
      return null;
    }

    /* Mark options/chips with NO available variant as unavailable.
       For <select>: append " — Sold out" and disable the option.
       For old chips (back-compat): toggle a class. */
    function refreshAvailability() {
      groupedWrap.querySelectorAll('.pdp-vgroup').forEach(function(grp, gIdx) {
        var dropdown = grp.querySelector('[data-pdp-group-select]');
        if (dropdown) {
          Array.prototype.forEach.call(dropdown.options, function(opt) {
            var raw = opt.getAttribute('data-raw') || opt.value;
            opt.setAttribute('data-raw', raw);
            var anyAvail = false;
            for (var j = 0; j < variantMap.length; j++) {
              var parts = variantMap[j].key.split('|||');
              if (parts[gIdx] === raw && variantMap[j].available) { anyAvail = true; break; }
            }
            opt.disabled = !anyAvail;
            opt.textContent = anyAvail ? raw : raw + ' — Sold out';
          });
          return;
        }
        grp.querySelectorAll('.pdp-vchip').forEach(function(chip) {
          var anyAvail = false;
          for (var j = 0; j < variantMap.length; j++) {
            var parts = variantMap[j].key.split('|||');
            if (parts[gIdx] === chip.getAttribute('data-value') && variantMap[j].available) { anyAvail = true; break; }
          }
          chip.classList.toggle('pdp-vchip--unavail', !anyAvail);
        });
      });
    }

    function applyVariant(v) {
      if (!v) return;
      /* Hidden id input */
      var idInput = document.querySelector('.pdp-form [name="id"]');
      if (idInput) idInput.value = v.id;

      /* Image */
      if (typeof window.vSwap === 'function' && v.image) window.vSwap(null, v.image);

      /* Prices */
      var priceEl = document.querySelector('.pdp-price');
      var compareEl = document.querySelector('.pdp-compare');
      var badgeEl = document.querySelector('.pdp-sale-badge');
      if (priceEl && v.price) priceEl.innerHTML = v.price;
      if (compareEl) {
        if (v.compare && v.compare !== v.price && v.compare !== '$0.00') {
          compareEl.innerHTML = v.compare;
          compareEl.hidden = false;
          if (badgeEl) badgeEl.hidden = false;
        } else {
          compareEl.hidden = true;
          if (badgeEl) badgeEl.hidden = true;
        }
      }

      /* URL */
      var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + v.id;
      window.history.replaceState({ path: newUrl }, '', newUrl);

      /* Availability UI */
      var atcBtn = document.querySelector('[data-pdp-atc]');
      var stockEl = document.querySelector('.pdp-stock');
      if (v.available) {
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('pdp-atc-btn--sold');
          var span = atcBtn.querySelector('span');
          if (span) span.textContent = 'Add to Cart'; else atcBtn.textContent = 'Add to Cart';
        }
        if (stockEl) {
          stockEl.className = 'pdp-stock pdp-stock--in';
          stockEl.innerHTML = '<span class="pdp-stock-dot"></span> In stock — ready to ship';
        }
      } else {
        if (typeof trovlyMarkSoldOut === 'function') trovlyMarkSoldOut('Currently sold out');
      }
    }

    /* Dropdown change handler */
    groupedWrap.querySelectorAll('[data-pdp-group-select]').forEach(function(sel) {
      sel.addEventListener('change', function() {
        var v = findVariant(currentSelection());
        applyVariant(v);
        refreshAvailability();
      });
    });

    groupedWrap.querySelectorAll('[data-pdp-group-btn]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var grp = btn.closest('.pdp-vgroup');
        if (!grp) return;
        grp.querySelectorAll('.pdp-vchip').forEach(function(b) { b.classList.remove('pdp-vchip--active'); });
        btn.classList.add('pdp-vchip--active');

        /* Update "(currently selected)" label */
        var gIdx = btn.getAttribute('data-group');
        var label = groupedWrap.querySelector('[data-current-for="' + gIdx + '"]');
        if (label) label.textContent = btn.getAttribute('data-value');

        var v = findVariant(currentSelection());
        applyVariant(v);
        refreshAvailability();
      });
    });

    refreshAvailability();
  }

  /* ── PDP variant selector — CSP-safe (no inline onclick) ── */
  var variantBtns = document.querySelectorAll('[data-pdp-variant]');
  if (variantBtns.length) {
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var vid = btn.getAttribute('data-variant-id');
        var idInput = document.querySelector('.pdp-form [name="id"]');
        if (idInput && vid) idInput.value = vid;
        variantBtns.forEach(function(b) { b.classList.remove('pdp-variant-btn--active'); });
        btn.classList.add('pdp-variant-btn--active');

        /* ── Update Main Image ── */
        var vimg = btn.getAttribute('data-variant-img');
        if (typeof window.vSwap === 'function' && vimg) {
          window.vSwap(null, vimg);
        }

        /* ── Update Prices ── */
        var vprice = btn.getAttribute('data-price');
        var vcompare = btn.getAttribute('data-compare-price');
        var priceEl = document.querySelector('.pdp-price');
        var compareEl = document.querySelector('.pdp-compare');
        var badgeEl = document.querySelector('.pdp-sale-badge');

        if (priceEl && vprice) priceEl.innerHTML = vprice;
        if (compareEl) {
          if (vcompare && vcompare !== '' && vcompare !== vprice) {
            compareEl.innerHTML = vcompare;
            compareEl.hidden = false;
            /* Update discount badge if it exists */
            if (badgeEl) {
              badgeEl.hidden = false;
              /* Optional: recalculate percentage here if needed, but for now we just show it */
            }
          } else {
            compareEl.hidden = true;
            if (badgeEl) badgeEl.hidden = true;
          }
        }

        /* ── Update URL ── */
        if (vid) {
          var newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + vid;
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }

        /* Update PDP UI based on the newly selected variant's availability */
        var available = btn.getAttribute('data-available') === 'true';
        var atcBtn = document.querySelector('[data-pdp-atc]');
        var stockEl = document.querySelector('.pdp-stock');
        if (available) {
          if (atcBtn) {
            atcBtn.disabled = false;
            atcBtn.classList.remove('pdp-atc-btn--sold');
            atcBtn.querySelector('span') ? (atcBtn.querySelector('span').textContent = 'Add to Cart') : (atcBtn.textContent = 'Add to Cart');
          }
          if (stockEl) {
            stockEl.className = 'pdp-stock pdp-stock--in';
            stockEl.innerHTML = '<span class="pdp-stock-dot"></span> In stock — ready to ship';
          }
        } else {
          trovlyMarkSoldOut('Currently sold out');
        }
      });
    });
  }

  /* ── Product page ATC (type="button", never submits form) ──
   *
   * The button has data-pdp-atc and type="button" so clicking it can NEVER
   * trigger a native form submission. No e.preventDefault() needed.
   * Handler lives here (external defer script) to avoid Shopify CSP blocking
   * inline <script> tags that lack a nonce.
   */
  /* ── Helper: flip PDP UI to "Sold Out" state ── */
  function trovlyMarkSoldOut(reason) {
    var btn = document.querySelector('[data-pdp-atc]');
    if (btn) {
      btn.textContent = 'Sold Out';
      btn.classList.add('pdp-atc-btn--sold');
      btn.disabled = true;
    }
    var stockEl = document.querySelector('.pdp-stock');
    if (stockEl) {
      stockEl.className = 'pdp-stock pdp-stock--out';
      stockEl.innerHTML = '<span class="pdp-stock-dot"></span> ' + (reason || 'Currently sold out');
    }
    /* Also hide Shopify's native dynamic checkout buttons (Shop Pay / PayPal etc.)
       so user can't bypass via express checkout when item is gone. */
    var dyn = document.querySelector('.shopify-payment-button');
    if (dyn) dyn.style.display = 'none';
  }

  /* ── Live stock check on page load ──
   *
   * Trust Shopify's own `available` flag — it already considers inventory
   * tracking, stock level, AND inventory policy ("deny" vs "continue").
   *   - tracked, qty>0           → available=true   (sell)
   *   - tracked, qty<=0, deny    → available=false  (sold out)
   *   - tracked, qty<=0, continue→ available=true   (merchant keeps selling)
   *   - untracked                → available=true   (sell)
   * Only flip to sold-out when Shopify itself says so.
   */
  var pdpForm   = document.querySelector('.pdp-form');
  var pdpIdInp  = pdpForm ? pdpForm.querySelector('[name="id"]') : null;
  var liveVarId = pdpIdInp ? parseInt(pdpIdInp.value, 10) : 0;
  if (liveVarId) {
    fetch('/variants/' + liveVarId + '.js', { cache: 'no-store' })
      .then(function(r) { return r.json(); })
      .then(function(v) {
        if (v && v.available === false) trovlyMarkSoldOut('Currently sold out');
      })
      .catch(function() {}); /* silent — don't break page if API unavailable */
  }

  /* ── Product page ATC (type="button", never submits form) ──
   *
   * The button has data-pdp-atc and type="button" so clicking it can NEVER
   * trigger a native form submission. Handler lives here (external defer
   * script) to avoid Shopify CSP blocking inline <script> without a nonce.
   */
  var pdpBtn = document.querySelector('[data-pdp-atc]');
  if (pdpBtn) {
    pdpBtn.addEventListener('click', function() {
      if (pdpBtn.disabled) return;
      var form     = document.querySelector('.pdp-form');
      var idInput  = form ? form.querySelector('[name="id"]')       : null;
      var qtyInput = form ? form.querySelector('[name="quantity"]') : null;
      var id  = idInput  ? parseInt(idInput.value,  10) : null;
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

      if (!id) { pdpBtn.textContent = 'Unavailable'; return; }

      pdpBtn.textContent = 'Adding…';
      pdpBtn.disabled    = true;

      var msgEl = document.getElementById('pdp-atc-msg');
      function showMsg(text, type) {
        if (!msgEl) return;
        msgEl.textContent = text;
        msgEl.className = 'pdp-atc-msg pdp-atc-msg--' + (type || 'info');
        msgEl.hidden = false;
      }
      function hideMsg() { if (msgEl) { msgEl.hidden = true; msgEl.textContent = ''; } }
      hideMsg();
      console.log('[TROVLY] Adding to cart:', { id: id, quantity: qty });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: id, quantity: qty })
      })
      .then(function(r) {
        return r.text().then(function(txt) {
          var data = {};
          try { data = JSON.parse(txt); } catch(e) {}
          console.log('[TROVLY] /cart/add.js status', r.status, 'body:', data);
          if (r.ok) return data;
          /* Build readable error message and classify */
          var raw = ((data.description || data.message || data.error || txt || '') + '').toLowerCase();
          /* SOLD-OUT detection: be strict — only confirmed inventory phrases.
             422 also fires for cart-limit, locked carts, currency mismatches, etc. */
          var isSoldOut =
            raw.indexOf('sold out')      !== -1 ||
            raw.indexOf('out of stock')  !== -1 ||
            (raw.indexOf('not enough')   !== -1 && raw.indexOf('stock') !== -1) ||
            raw.indexOf('inventory')     === 0;
          var err = new Error(isSoldOut ? 'SOLD_OUT' : (data.description || data.message || 'Add failed'));
          err.serverMessage = data.description || data.message || ('HTTP ' + r.status);
          throw err;
        });
      })
      .then(function() {
        if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
        showMsg('✓ Added to cart', 'ok');
        pdpBtn.textContent = '✓ Added';
        setTimeout(function() {
          var span = pdpBtn.querySelector('span');
          if (span) span.textContent = 'Add to Cart'; else pdpBtn.textContent = 'Add to Cart';
          pdpBtn.disabled = false;
          hideMsg();
        }, 2000);
      })
      .catch(function(err) {
        console.error('[TROVLY] Add to cart failed:', err && err.serverMessage, err);
        var span = pdpBtn.querySelector('span');
        if (err && err.message === 'SOLD_OUT') {
          trovlyMarkSoldOut('Just sold out — check back soon');
          showMsg('Sold out: ' + (err.serverMessage || 'no stock'), 'err');
        } else {
          /* Always surface the REAL Shopify error so user can see it on-page (no DevTools needed) */
          showMsg('Cart error: ' + (err && err.serverMessage ? err.serverMessage : 'unknown'), 'err');
          if (span) span.textContent = 'Try Again'; else pdpBtn.textContent = 'Try Again';
          pdpBtn.disabled = false;
          setTimeout(function() {
            if (span) span.textContent = 'Add to Cart'; else pdpBtn.textContent = 'Add to Cart';
            pdpBtn.disabled = false;
          }, 2500);
        }
      });
    });
  }

  /* ── Global AJAX add-to-cart (collection quick-buy cards only) ──
   *
   * The product page uses a type="button" ATC (handled above) — it never
   * fires a form submit. This catches any other add-to-cart forms (quick-buy
   * cards in collection grids, etc.).
   */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.classList.contains('pdp-form')) return;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;

    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var originalText = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    var formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d){ throw new Error(d.description || 'Error'); });
      return r.json();
    })
    .then(function() {
      if (btn) {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 900);
      }
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
    })
    .catch(function(err) {
      if (btn) { btn.textContent = err.message || 'Error'; btn.disabled = false; }
      console.error('[TROVLY] Add to cart failed:', err);
    });
  });

  /* ── Collection card Quick-Add buttons ──
   *
   * Single-variant products: [data-quick-add] with data-variant-id → direct add.
   * Multi-variant: opens Quick View (handled via onclick in markup, not here).
   * Delegated on document so dynamically loaded cards also work.
   */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn || btn.disabled) return;
    var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!vid) return;

    var icon = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
    var saved = btn.innerHTML;
    btn.innerHTML = 'Adding…';
    btn.disabled  = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) {
        return r.json().then(function(d) {
          var raw = ((d.description || d.message || '') + '').toLowerCase();
          var isOut = raw.indexOf('sold out') !== -1 || raw.indexOf('not enough') !== -1;
          throw new Error(isOut ? 'SOLD_OUT' : 'ERR');
        });
      }
      return r.json();
    })
    .then(function() {
      btn.innerHTML = icon + '<span>✓ Added</span>';
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      setTimeout(function() { btn.innerHTML = saved; btn.disabled = false; }, 1400);
    })
    .catch(function(err) {
      if (err && err.message === 'SOLD_OUT') {
        btn.textContent = 'Sold Out';
        btn.classList.add('product-card__quick-add--sold');
      } else {
        btn.innerHTML = saved;
        btn.disabled = false;
      }
    });
  });

  /* ── Scroll Reveal ── */
  if (typeof IntersectionObserver !== 'undefined') {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) entry.target.classList.add('revealed');
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.shopify-section').forEach(function(section) {
      section.classList.add('reveal-init');
      revealObserver.observe(section);
    });
  }

});

/* ── Cart count badge (called from cart-drawer snippet after updates) ── */
function updateCartCount(count) {
  var badge = document.getElementById('CartCount');
  if (!badge) return;
  badge.textContent = count;
  badge.classList.toggle('hidden', count === 0);
}
